import React from "react"
import { Container, Typography } from "@mui/material"

export default function HeaderBlock(props) {
  const {
    title,
    titleComponent,
    description,
    topGutterSpacing,
    bottomGutterSpacing,
  } = props

  return (
    <Container
      sx={{
        paddingTop: topGutterSpacing || 0,
        marginBottom: bottomGutterSpacing || 0,
      }}
      maxWidth="sm"
    >
      <Typography
        variant="h5"
        component={titleComponent || "p"}
        align="center"
        sx={{
          paddingBottom: 1,
          color: `titles.main`,
          fontWeight: "bold",
          fontSize: "30px",
          textTransform: "uppercase",
        }}
      >
        {title}
      </Typography>
      {description && <Typography align="center">{description}</Typography>}
    </Container>
  )
}
